import axios from "axios";
import { auth } from "@/lib/firebase";

// Axios client for the Brugo super-admin backend proxy. Every request carries
// the signed-in ops user's Firebase ID token; the backend verifies it and the
// `role` custom claim before performing any admin (rule-bypassing) operation.
const api = axios.create({ baseURL: (process.env.REACT_APP_BACKEND_URL || "") + "/api" });

api.interceptors.request.use(async (config) => {
  const u = auth?.currentUser;
  if (u) {
    const token = await u.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
